<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="3">
        <v-select
          v-model="adAccount"
          :items="adAccounts"
          item-text='name'
          item-value='account_id'
          label="Select Page"
          @change="loadDifferentPages(adAccount)"
        >
        </v-select>
      </v-col>
      <v-col cols="6" class="text-center">
        <h1 class="compeatfont">Facebook Live Data</h1>
      </v-col>
      <v-col cols="3">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="dates"
          transition="scale-transition"
          offset-y
          width="350px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="formattedDateRange"
              label="Date Range"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-row class="py-3 px-3 bgwhite">
            <v-col cols="4">
              <h3 class="mb-2">Select Dates</h3>
              <v-radio-group v-model="range">
                <v-radio
                  @click="onRangeChange()"
                  v-for="n in rangeItems"
                  :key="n.value"
                  :label="n.name"
                  :value="n.value"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="8">
              <v-date-picker
                :max="today"
                :min="maxDays"
                v-model="dates"
                no-title
                scrollable
                range
                :disabled-dates="disableFutureDates"
                @input="checkForChange()"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="handleDateSelection()">
                  OK
                </v-btn>
              </v-date-picker>
            </v-col>
          </v-row>
        </v-menu>
      </v-col>
      <v-col cols="12">
        <v-tabs rounded v-model="tab" class="white" grow icons-and-text>
          <v-tab :key="0">
            <h2 class="compeatfont">{{ this.reachTotal | formatToK }}</h2>
            <h3 class="compeatfont">Reach 
              <v-tooltip right max-width="300px">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small v-bind="attrs" v-on="on">mdi-information</v-icon>
                </template>
                <span class="py-3 px-3">Total reach count for the last  {{ reachLineGraphHeadings.length }} days.</span>
              </v-tooltip>
            </h3>
          </v-tab>
          <v-tab :key="1">
            <h2 class="compeatfont">{{ this.linksTotal | formatToK }}</h2>
            <h3 class="compeatfont">Links 
              <v-tooltip right max-width="300px">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small v-bind="attrs" v-on="on">mdi-information</v-icon>
                </template>
                <span class="py-3 px-3">Total Links Clicks count for the last  {{ reachLineGraphHeadings.length }} days.</span>
              </v-tooltip>
            </h3>
          </v-tab>
          <v-tab :key="2">
            <h2 class="compeatfont">
              {{ this.lifeTimeFollowers | formatToK }}
            </h2>
            <h3 class="compeatfont">Follows 
              <v-tooltip right max-width="300px">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small v-bind="attrs" v-on="on">mdi-information</v-icon>
                </template>
                <span class="py-3 px-3">Total Followers count for the last  {{ reachLineGraphHeadings.length }} days.</span>
              </v-tooltip>
            </h3>
          </v-tab>
          <v-tab :key="3">
            <h2 class="compeatfont">{{ this.postCount }}</h2>
            <h3 class="compeatfont">Posts 
              <v-tooltip right max-width="300px">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small v-bind="attrs" v-on="on">mdi-information</v-icon>
                </template>
                <span class="py-3 px-3">Total Post count for the last  {{ reachLineGraphHeadings.length }} days.</span>
              </v-tooltip>
            </h3>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item :key="0">
            <!-- <div id="report-content" class="pdf-container"> -->
            <v-row>
              <v-col cols="9">
                <v-card flat>
                  <v-card-text>
                    <h2 class="compeatfont">
                      Reach for the last
                      {{ reachLineGraphHeadings.length }} days
                    </h2>
                    <lineChart
                      :data="reachLineGraphData"
                      :headings="reachLineGraphHeadings"
                      :title="reachTitle"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="3">
                <h2 class="compeatfont">Reach breakdown</h2>
                <v-card class="my-3">
                  <v-card-text>
                    <h3 class="compeatfont">Total</h3>
                    <h1 class="compeatfont">
                      {{ this.reachTotal | toThreeDecimals }}
                    </h1>
                  </v-card-text>
                </v-card>
                <v-card class="my-3">
                  <v-card-text>
                    <h3 class="compeatfont">Organic</h3>
                    <h1 class="compeatfont">
                      {{ this.reachOrganic | toThreeDecimals }}
                    </h1>
                  </v-card-text>
                </v-card>
                <v-card class="my-3">
                  <v-card-text>
                    <h3 class="compeatfont">Paid</h3>
                    <h1 class="compeatfont">
                      {{ this.reachPaid | toThreeDecimals }}
                    </h1>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <!-- </div> -->
          </v-tab-item>
          <v-tab-item :key="1">
            <v-row>
              <v-col cols="9">
                <v-card flat>
                  <v-card-text>
                    <h2 class="compeatfont">
                      Link clicks for the last
                      {{ linksLineGraphHeadings.length }} days
                    </h2>
                    <lineChart
                      :data="linksLineGraphData"
                      :headings="linksLineGraphHeadings"
                      :title="linksTitle"
                    />
                    <!-- <apexchart height="500px" type="line" :options="linksChartOptions" :series="linksLineGraphData"></apexchart> -->
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="3">
                <h2 class="compeatfont">Links breakdown</h2>
                <v-card class="my-3">
                  <v-card-text>
                    <h3 class="compeatfont">Link Clicks</h3>
                    <h1 class="compeatfont">
                      {{ this.linksTotal | toThreeDecimals }}
                    </h1>
                  </v-card-text>
                </v-card>
                <v-card class="my-3">
                  <v-card-text>
                    <h3 class="compeatfont">Photo Clicks</h3>
                    <h1 class="compeatfont">
                      {{ this.photoClick | toThreeDecimals }}
                    </h1>
                  </v-card-text>
                </v-card>
                <v-card class="my-3">
                  <v-card-text>
                    <h3 class="compeatfont">Other Clicks</h3>
                    <h1 class="compeatfont">
                      {{ this.otherClicks | toThreeDecimals }}
                    </h1>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :key="2">
            <v-row>
              <v-col cols="9">
                <v-card flat>
                  <v-card-text>
                    <h2 class="compeatfont">
                      Followers count for the last
                      {{ followsLineGraphHeadings.length }} days
                    </h2>
                    <lineChart
                      :data="followsLineGraphData"
                      :headings="followsLineGraphHeadings"
                      :title="linksTitle"
                    />
                    <!-- <apexchart height="500px" type="line" :options="linksChartOptions" :series="linksLineGraphData"></apexchart> -->
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="3">
                <h2 class="compeatfont">Followers breakdown</h2>
                <v-card class="my-3">
                  <v-card-text>
                    <h3 class="compeatfont">Net Followers</h3>
                    <h1 class="compeatfont">
                      {{ this.netFollows | toThreeDecimals }}
                    </h1>
                  </v-card-text>
                </v-card>
                <v-card class="my-3">
                  <v-card-text>
                    <h3 class="compeatfont">Follows</h3>
                    <h1 class="compeatfont">
                      {{ this.followsTotal | toThreeDecimals }}
                    </h1>
                  </v-card-text>
                </v-card>
                <v-card class="my-3">
                  <v-card-text>
                    <h3 class="compeatfont">Unfollows</h3>
                    <h1 class="compeatfont">
                      {{ this.unfollowsTotal | toThreeDecimals }}
                    </h1>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :key="3">
            <v-card elevation="2">
              <v-card-text>
                <v-row>
                  <v-col cols="9">
                    <h2 class="compeatfont">
                      Posts for the last {{ range }} days
                    </h2>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                      v-model="sortCriteria"
                      :items="sortOptions"
                      label="Sort by"
                    ></v-select>
                  </v-col>
                  <v-col
                    @click="open(item)"
                    cols="12"
                    v-for="item in sortedPostsContent"
                    :key="item.id"
                  >
                    <v-row justify="center" align="center">
                      <v-col cols="1">
                        <v-img
                          :src="item.postData.full_picture"
                          width="100px"
                        />
                      </v-col>
                      <v-col cols="5">
                        <v-tooltip left max-width="300px">
                          <template v-slot:activator="{ on, attrs }">
                            <h3 v-bind="attrs" v-on="on">
                              {{ item.postData.message | truncateText(100) }}
                            </h3>
                          </template>
                          <span class="py-3 px-3">{{
                            item.postData.message
                          }}</span>
                        </v-tooltip>
                        <h3>
                          Created at
                          {{ item.postData.created_time | formateDate }}
                        </h3>
                      </v-col>
                      <v-col cols="2" class="text-center">
                        <v-card>
                          <v-card-text>
                            <h4 class="mb-2 compeatfont">REACH</h4>
                            <h1 class="compeatfont">
                              {{ item.reach | formatToK }}
                            </h1>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="2" class="text-center">
                        <v-card>
                          <v-card-text>
                            <h4 class="mb-2 compeatfont">IMPRESSIONS</h4>
                            <h1 class="compeatfont">
                              {{ item.impressions | formatToK }}
                            </h1>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="2" class="text-center">
                        <v-card>
                          <v-card-text>
                            <h4 class="mb-2 compeatfont">LIKE & REACTIONS</h4>
                            <h1 class="compeatfont">{{ item.interactions }}</h1>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-text class="py-4">
          <!-- {{ this.selectedItem }} -->
          <v-row>
            <v-col cols="3">
              <v-img :src="this.selectedItem.full_picture" />
            </v-col>
            <v-col cols="9">
              <h4>{{ this.selectedItem.message | truncateText(100) }}</h4>
              {{ this.selectedItem.created_time | formateDate }}
              <h4>posted by {{this.selectedItemCreator}}</h4>
            </v-col>
            <v-col cols="4" class="text-center">
              <v-card>
                <v-card-text>
                  <h4 class="mb-2 compeatfont">REACH</h4>
                  <h1 class="compeatfont">
                    {{ this.selectedItemData.reach | formatToK }}
                  </h1>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="text-center">
              <v-card>
                <v-card-text>
                  <h4 class="mb-2 compeatfont">IMPRESSIONS</h4>
                  <h1 class="compeatfont">
                    {{ this.selectedItemData.impressions | formatToK }}
                  </h1>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="text-center">
              <v-card>
                <v-card-text>
                  <h4 class="mb-2 compeatfont">LINK CLICKS</h4>
                  <h1 class="compeatfont">
                    {{ this.selectedItemData.linkClicks }}
                  </h1>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="text-center">
              <v-card>
                <v-card-text>
                  <h4 class="mb-2 compeatfont">INTERACTIONS</h4>
                  <h1 class="compeatfont">
                    {{ this.selectedItemData.interactions }}
                  </h1>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="text-center">
              <v-card>
                <v-card-text>
                  <h4 class="mb-2 compeatfont">REACTIONS</h4>
                  <h1 class="compeatfont">
                    {{ this.selectedItemData.reactions }}
                  </h1>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4" class="text-center">
              <v-card>
                <v-card-text>
                  <h4 class="mb-2 compeatfont">SHARES</h4>
                  <h1 class="compeatfont">
                    {{ this.selectedItemData.shares }}
                  </h1>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn @click="close()">
                Close
              </v-btn>
            </v-col>
            
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
     <!-- Show the previewed image -->
     <!-- <div v-if="previewImage" class="image-preview">
      <h3>Preview:</h3>
      <img :src="previewImage" alt="Image Preview" />
    </div> -->

    <!-- Button to trigger PDF export -->
    <!-- <button @click="generateImage()">Export to PDF</button> -->
  </v-container>
</template>

<script>
import jsPDF from "jspdf"; // Import jsPDF library
import html2canvas from "html2canvas"; // Import html2canvas library
import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "../firebaseConfig";
import moment from "moment-timezone";
import lineChart from "../components/charts/lineChart.vue";
export default {
  components: {
    lineChart,
  },
  data: () => ({
    dialog: false,
    dates: [],
    today: moment().format("YYYY-MM-DD"),
    maxDays: moment().subtract(90, "days").format("YYYY-MM-DD"),
    menu: false,
    modal: false,
    menu2: false,
    range: 29,
    rangeItems: [
      { name: "7 Days", value: 8 },
      { name: "28 Days", value: 29 },
      { name: "60 Days", value: 61 },
      { name: "90 Days", value: 91 },
      { name: "Custom", value: 0 },
    ],
    facebookData: [],

    //varibles for data
    engagement: [],
    audience: [],
    posts: [],
    reach: [],
    video: [],
    links: [],
    reachTotal: 0,
    disableFutureDates: [
      {
        dates: (date) => {
          const today = moment().startOf("day"); // Ensures it's set to the start of the day
          return moment(date).isAfter(today, "day"); // Check if the date is in the future
        },
        customData: { isDisabled: true },
      },
    ],
    tab: null,

    //Reach Data
    reachLineGraphHeadings: {},
    reachLineGraphData: [],
    reachTitle: "",
    reachOrganic: 0,
    reachPaid: 0,

    //Links Data
    linksTotal: 0,
    linksLineGraphData: [],
    linksLineGraphHeadings: {},
    linksTitle: "",
    photoClick: 0,
    otherClicks: 0,
    linksChartOptions: {},

    //follows
    followsTotal: 0,
    unfollowsTotal: 0,
    netFollows: 0,
    followsLineGraphHeadings: {},
    followsLineGraphData: [],
    lifeTimeFollowers: 0,

    //Post Content
    postsContent: [],
    postCount: 0,
    selectedItem: {},
    selectedItemData: {},
    selectedItemCreator:'',

    sortCriteria: '', // default sorting criteria
    sortOptions: [
        { text: 'Reach', value: 'reach' },
        { text: 'Impressions', value: 'impressions' },
        { text: 'Interactions', value: 'interactions' }
      ],

     adAccounts:[],
     adAccount:{},

     fbToken:"EAAKd8EjhoecBO8bEIwJtyOxnHF5NEUfZAuqdas9FwR8MBJP8AZA9ZCpDdfsamHwhKmbQ2902pZBGQesKI4KZAGmXkJlorHpmAFoFbiT6GoYLebfuRtgIzFy7o0upqgQfA5jMJ2iEfj7RljaNYuCUTsC2PtzT6mqH2jNdKbZCufZAD8r3Boy7ZABG4D9doPqCqE8h",
    pageId:"931439880250915",
    previewImage: null,
  }),
  computed: {
    sortedPostsContent() {
      // Sort the postsContent based on the selected criteria
      return this.postsContent.sort((a, b) => {
        return b[this.sortCriteria] - a[this.sortCriteria]; // descending order
      });
    },
    dateRangeText() {
      return this.dates.join(" ~ ");
    },
    formattedDateRange() {
      if (this.dates.length === 2) {
        // Ensure dates are sorted in ascending order
        const sortedDates = this.dates.sort((a, b) =>
          moment(a).diff(moment(b))
        );

        // Return the formatted date range
        return `${moment(sortedDates[0]).format("DD MMM, YYYY")} - ${moment(
          sortedDates[sortedDates.length - 1]
        ).format("DD MMM, YYYY")}`;
      } else if (this.dates.length === 1) {
        // For a single date, just format it
        return `${moment(this.dates[0]).format("DD MMM, YYYY")}`;
      }
    },
  },
  filters: {
    truncateText(text, maxLength) {
      if (!text) {
        return "";
      }
      return text.length > maxLength
        ? text.substring(0, maxLength) + "..."
        : text;
    },
    formatToK(value) {
      if (!value) return "";
      // Convert the number to a thousand-based unit
      let kValue = value / 1000;

      // Format the value to one decimal place and add "K"
      return kValue.toFixed(1) + " K";
    },
    toThreeDecimals(value) {
      if (value === null || value === undefined) {
        return 0;
      }

      if (value < 1000) {
        return value.toString();
      }

      if (value >= 1000 && value < 1000000) {
        let kValue = value / 1000;
        return kValue.toFixed(3);
      }

      if (value >= 1000000) {
        return value.toLocaleString("de-DE"); // Format with periods
      }

      return value.toString();
    },
    formateDate(date) {
      if (!date) {
        return "";
      }
      const formattedTime = moment(date).format("HH:mm"); // Time in 24-hour format
      const formattedDate = moment(date).format("YYYY-MM-DD"); // Date
      return `${formattedTime} on ${formattedDate}`;
    },
  },
  created() {
    if (this.range === 8) {
      this.updateDates(8);
      this.range = this.rangeItems[0].value;
    } else if (this.range === 29) {
      this.updateDates(29);
      this.range = this.rangeItems[1].value;
    } else if (this.range === 61) {
      this.updateDates(61);
      this.range = this.rangeItems[2].value;
    } else if (this.range === 91) {
      this.updateDates(91);
      this.range = this.rangeItems[3].value;
    } else if (this.range === 0) {
      this.range = this.rangeItems[4].value;
    }

    this.getAdAccounts()
  },
  methods: {
    // async generateImage() {
    //   const element = document.getElementById("report-content");

    //   const canvas = await html2canvas(element); // Generate the canvas
    //   const imgData = canvas.toDataURL("image/png"); // Convert canvas to base64 image

    //   this.previewImage = imgData; // Set the preview image
    // },
    getAdAccounts(){
      console.log('this.$store.state.user.facebookToken', this.$store.state.user.facebookToken)
      try {
        const functions = getFunctions(firebaseApp, "europe-west2");
        const getPagesForUsers = httpsCallable(functions, "getPagesForUsers");

        getPagesForUsers({
          userToken: this.$store.state.user.facebookToken,
        }).then((result) => {
          console.log('result.data.response', result.data.response.data)
          this.adAccounts = result.data.response.data
        });
      } catch (err) {
        console.log("err", err);
      }
    },
    loadDifferentPages(item){
      console.log('item', item)
      this.adAccounts.forEach((account) => {
        if(account.name === item) {
          console.log('account', account)

          this.fbToken = account.access_token
          this.pageId = account.id
        }
      })

      this.getData()
    },
    open(item) {
      console.log("hello", item);
      this.dialog = true;
      this.selectedItem = item.postData;
      this.selectedItemData = item;
      this.selectedItemCreator = item.postData.admin_creator.name
    },
    close(){
      this.dialog = false;
      this.selectedItem = {};
      this.selectedItemData = {};
      this.selectedItemCreator = ''
    },
    checkForChange() {
      console.log(this.dates);
      this.range = this.rangeItems[4].value;
    },
    handleDateSelection() {
      this.$refs.menu.save(this.dates); // Ensure the ref is saved
      this.menu = false; // Close the menu
      // this.doSomethingWithDates(); // Call your function
      if (this.dates.length == 2) {
        this.since = this.dates[0];
        this.until = this.dates[1];
        console.log("since", this.since);
        console.log("until", this.until);
        this.getData();
      } else if (this.dates.length == 1) {
        this.since = this.dates[0];
        this.until = this.dates[0];
        console.log("since", this.since);
        console.log("until", this.until);
        this.getData();
      }
    },
    // Method to update dates based on the selected range
    updateDates(dayCount) {
      // Define the end date as today's date
      const endDate = moment().startOf("day");

      // Define the start date by subtracting 27 days from the end date
      const startDate = endDate
        .clone()
        .subtract(dayCount - 1, "days")
        .startOf("day");

      // Create an array of dates for the specified day count (28 days total)
      const allDates = Array.from({ length: dayCount }, (_, index) => {
        return startDate.clone().add(index, "days").format("YYYY-MM-DD");
      });

      // Only keep the first and last date from all dates
      this.dates = [allDates[0], allDates[allDates.length - 1]];
      this.since = this.dates[0];
      this.until = this.dates[1];
      this.getData();
    },
    // Handle changes to the radio group
    onRangeChange() {
      const dayCount = parseInt(this.range, 10); // Get the selected range as an integer
      console.log("dayCount", dayCount);
      this.updateDates(dayCount);
      this.facebookData = []; // Update dates based on the selected range
    },
    getData() {
      this.facebookData = [];
      this.linksChartOptions = {};
      this.reachLineGraphHeadings = {};

      // let fbToken =
      //   "EAAKd8EjhoecBO8bEIwJtyOxnHF5NEUfZAuqdas9FwR8MBJP8AZA9ZCpDdfsamHwhKmbQ2902pZBGQesKI4KZAGmXkJlorHpmAFoFbiT6GoYLebfuRtgIzFy7o0upqgQfA5jMJ2iEfj7RljaNYuCUTsC2PtzT6mqH2jNdKbZCufZAD8r3Boy7ZABG4D9doPqCqE8h";
      // let pageId = "931439880250915";
      try {
        const functions = getFunctions(firebaseApp, "europe-west2");
        const facebookLiveData = httpsCallable(functions, "facebookLiveData");

        facebookLiveData({
          fbToken: this.fbToken,
          pageId: this.pageId,
          since: this.since,
          until: this.until,
        }).then((result) => {
          this.facebookData = result.data.response;
          this.reach = this.facebookData.reach;
          this.links = this.facebookData.linkClick;
          this.follows = this.facebookData.follows;
          this.postsContent = this.facebookData.content;
          this.getReachData();
          console.log("this.facebookData", this.facebookData);
        });
      } catch (err) {
        console.log("err", err);
      }
    },
    getReachData() {
      this.reachTotal = this.reach.totals.overAll;
      this.reachOrganic = this.reach.totals.organic;
      this.reachPaid = this.reach.totals.paid;
      this.reachLineGraphHeadings =
        this.reach.page_impressions_unique_days.dates;
      this.reachTitle = "Reach Total";
      this.reachLineGraphData = [
        {
          name: "Total Reach",
          data: this.reach.page_impressions_unique_days.values,
        },
        {
          name: "Organic",
          data: this.reach.page_impressions_organic_unique_v2_days.values,
        },
        {
          name: "Paid",
          data: this.reach.page_impressions_paid_unique_days.values,
        },
      ];
      this.getLinksData();
    },
    getLinksData() {
      this.linksTotal = this.links.totalValuesForEachHeading["link clicks"];
      this.photoClick = this.links.totalValuesForEachHeading["photo view"];
      this.otherClicks = this.links.totalValuesForEachHeading["other clicks"];
      this.linksLineGraphHeadings = this.links.dates;
      this.linksTitle = "Links Total";
      this.linksLineGraphData = this.links.dataSets;
      this.getFollowData();
    },
    getFollowData() {
      this.followsTotal = [];
      this.unfollowsTotal = [];
      this.netFollows = [];

      this.followsTotal = this.follows.totals.follows;
      this.unfollowsTotal = this.follows.totals.unFollows;
      this.netFollows = this.follows.totals.netFollows;
      this.lifeTimeFollowers = this.follows.lifeTimeTotal;
      this.followsLineGraphHeadings = this.follows.dailyFollows.dates;

      this.followsLineGraphData = [
        {
          name: "Total Daliy Follows",
          data: this.follows.dailyFollows.values,
        },
        {
          name: "Total Daliy Unfollows",
          data: this.follows.dailyUnfollows.values,
        },
      ];
      this.getPostContentData();
    },
    getPostContentData() {
      // this.postsContent = []
      this.postCount = this.postsContent.postsCount;
      this.postsContent = this.postsContent.postTotals;
    },
  },
};
</script>

<style>
.v-menu__content {
  width: 500px;
}
.bgwhite {
  background: white !important;
}

.report-container {
  padding: 20px; /* Padding on all sides */
  background-color: #f0f0f0; /* Light gray background */
}

.pdf-container {
  background-color:white !important
}

</style>
